export default __webpack_public_path__ + "static/O0273-583c42e161138e958dca1180245a7498.png";